<template>
	<div class="society">
		<div class="header" style="background: white;">
			<div class="container">
				<div class="flex">
					<div class="logo"><img src="../image/zsdb_logo.png" class="logoImg" style="width:132px"></div>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a @click="gotoHome()" class="">首页</a></li>
							<li class="menulist"><a @click="gotoRecruit()" class="">招聘公告</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a class="on">社会招聘</a></li>
							<!-- <li class="menulist"><a @click="gotoIntern()" class="">实习生招聘</a></li> -->
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../image/ewm.jpg" class="code">
						<img src="../image/icoewm.png" slot="reference" class="ico">
					</el-popover>

				</div>
			</div>
		</div>

		<div class="pagesbanner">
			<img src="../image/xydh01.png" class="dh wow  fadeInLeft" style="left: 0">
			<img src="../image/shdh02.png" class="dh wow  fadeInLeft" style="right: 0">
			<div class="text">
				<h3>社会招聘</h3>
				<p>Social recruitment</p>
			</div>
		</div>
		<a name="zw" style="position: relative;top: -80px;"></a>
		<div class="nidrpages">
			<div class="searchbody">
				<div class="search">
					<el-input v-model="input" placeholder="请输入职位关键词"></el-input>
					<button class="search_btn" @click="jobsearch()"><img src="../image/search.png"></button>
				</div>
			</div>
			<div class="joblistbody" v-infinite-scroll="load">
				<jobinfo v-for="(item,index) in campusjobinfo" :key="index" :campusjobinfo="item"
					v-on:transferpositionID='transferpositionID' v-show="haveshowposition" style="display: none;">
				</jobinfo>
				<div class="noneposition" v-show="noneshowposition" style="display: none;">
					<img src="../image/noneposition.png" class="nonepositionimg" /><br />
					<span class="nonepositiontext">暂无岗位</span>
				</div>
			</div>
		</div>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
		<backtop></backtop>
	</div>
</template>

<script>
	import jobinfo from "../components/jobinfo.vue"
	import backtop from "../components/backtop.vue"
	import {
		loginstatus,
		Logout,
		queryPosition,
		collectPosition,
		requestPosition,
	} from '../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			jobinfo,
			backtop,
		},

		data() {
			return {
				campusjobinfo: [],
				input: '',
				islogin: false,
				unlogin: false,
				haveshowposition: false,
				noneshowposition: false,
				userId: '',
			}
		},

		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
					this.userId = res.data;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			});

			queryPosition({
				positionName: "",
			}).then((res) => {
				var i = 0
				var j = 0
				var arr = new Array()
				console.log(res.data)
				for (i; i < res.data.length; i++) {
					if (res.data[i].type == 1) {
						arr[j] = res.data[i]
						j++
					}
				}
				if (arr.length != 0) {
					this.campusjobinfo = arr
					this.haveshowposition = true
					this.noneshowposition = false
				} else {
					this.haveshowposition = false
					this.noneshowposition = true
				}
			});
		},

		methods: {
			load() {
				this.count += 2
			},
			transferpositionID(transferpositionID) {
				if (transferpositionID.type == 0) {
					collectPosition({
						positionID: transferpositionID.positionID,
						userID: this.userId,
					}).then((res) => {
						if (res.code == 200) {
							this.$message({
								message: '收藏成功！',
								type: 'success'
							});
						} else {
							this.$message({
								message: '收藏失败！',
								type: 'error'
							});
						}
					});
				} else if (transferpositionID.type == 1) {
					this.$confirm('岗位投递后将不可再进行修改，请确认无误后投递。', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						requestPosition({
							order: transferpositionID.order,
							positionID: transferpositionID.positionID,
							userID: this.userId,
						}).then((res) => {
							this.dialogPositionStats = false;
							this.requestOrderDialog = false
							if (res.code == 200) {
								this.$message({
									message: '投递成功！',
									type: 'success'
								});
							} else if (res.code == 40098) {
								this.$confirm('您尚未完善与提交简历，若需投递岗位请先前往个人中心创建您的简历', '提示', {
									confirmButtonText: '前往个人中心',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									this.$router.push('/personal/resume')
								}).catch(() => {

								});
							} else if (res.code == 40099) {
								this.$message({
									message: '简历类型与所投岗位类型不匹配！',
									type: 'error'
								});
							} else if (res.code == 50099) {
								this.$message({
									message: '岗位不存在！',
									type: 'error'
								});
							} else if (res.code == 40002) {
								this.$message({
									message: '已申请两个岗位，请前往个人中心调整！',
									type: 'error'
								});
							} else if (res.code == 40003) {
								this.$message({
									message: '已存在申请岗位，请前往个人中心调整！',
									type: 'error'
								});
							} else if (res.code == 48848) {
								this.$message({
									message: res.msg,
									type: 'error'
								});
							}
						})
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消投递'
						});
					});
				}
			},
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			gotoRecruit() {
				this.$router.push('/recruitInfoList')
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotoHome() {
				this.$router.push('/')
			},
			gotoAboutus() {
				this.$router.push('/aboutus/introduce')
			},
			gotoCampus() {
				this.$router.push('/campus')
			},
			// gotoSociety() {
			// 	this.$router.push('/society')
			// },
			gotoIntern() {
				this.$router.push('/intern')
			},
			jobsearch() {
				queryPosition({
					positionName: this.input,
				}).then((res) => {
					var i = 0
					var j = 0
					var arr = new Array()
					for (i; i < res.data.length; i++) {
						if (res.data[i].type == 1) {
							arr[j] = res.data[i]
							j++
						}
					}
					if (arr.length != 0) {
						this.campusjobinfo = arr
						this.haveshowposition = true
						this.noneshowposition = false
					} else {
						this.haveshowposition = false
						this.noneshowposition = true
					}
				});
			},
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}
</script>

<style scoped>
	@import url(../assets/css/index.css);

	.searchbody {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		width: 1150px;
		height: 70px;
		margin-left: 20%;
		background-color: white;
		border-radius: 30px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		padding-top: 14px;
		padding-left: 55px;
	}

	.search {
		display: flex;
		width: 90%;
	}

	.joblistbody {
		background-color: white;
		width: 1150px;
		margin-top: 35px;
		margin-left: 20%;
		/* margin-bottom: 35px; */
		border-radius: 2px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}

	.search_btn {
		background-color: #0056b1;
		width: 100px;
		height: 40px;
		margin-left: 25px;
		border: none;
		cursor: pointer;
	}

	.pagesbanner {
		background: url(../image/bannersh.jpg) top center no-repeat;
	}

	.nidrpages {
		min-height: calc(100vh - 460px) !important;
		background-color: #e5eef7;
		padding-bottom: 35px;
		padding-top: 35px;
	}
</style>
